<template>
    <v-dialog v-model="dialog" width=80%>
        <v-container style="min-height: 80vh; background-color: white;" class="px-8">
        
            <div><h1>{{ text.type }} {{ text.language }}</h1></div>
        
            <div class="mt-6" style="font-weight: 500; font-size: 14pt;">Selected text - this text will be used as a base for the translation</div>
            <v-textarea v-model="text.text" rows="5" :readonly="true" counter no-resize />

            <div style="display: flex; flex-direction: column; align-items:flex-start ; gap: 10px;">
                <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
                    <v-icon color="success">mdi-numeric-1-circle</v-icon>
                    <div style="min-width: 250px;">Choose the translation tool</div>
                    <v-radio-group v-model="translation_tool" dense hide-details row :value="content" :disabled="loading" class="mt-0">
                        <v-radio key='0' label="Google" :value=0 style="margin-left: -4px"></v-radio>
                        <v-radio key='1' label="Deepl" :value=1></v-radio>
                        <v-radio key='2' label="ChatGPT" :value=2></v-radio>
                    </v-radio-group>             
                </div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
                    <v-icon color="success">mdi-numeric-2-circle</v-icon>
                    <div style="min-width: 250px;">Select the target language</div>
                    <v-select dense v-model="sel_language" :items="text.translatableTo" item-value="code" item-text="description" @change="translation=''" :disabled="loading"></v-select>
                    <div style="font-style: italic; font-weight: 300; margin-bottom: 10px; margin-left: 20px;">You cannot select the source language ({{ text.language }}) or the language of any text the guest has entered</div>
                </div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
                    <v-icon color="success">mdi-numeric-3-circle</v-icon>
                    <div style="min-width: 250px;">Start the translation ({{ text.language }} > {{ sel_language }})</div>
                    <v-btn small color="primary" :loading="loading" @click="translate()" :disabled="sel_language===''">translate</v-btn>                    
                </div>                      
                <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
                    <v-icon color="transparent">mdi-numeric-2-circle</v-icon>
                    <div style="font-style: italic; font-weight: 300;"> ProTIP: if the source language is not FR, DE, NL or EN, you will get the best result when you translate to EN with ChatGPT and use that for any other translations</div>
                </div>      
            </div>

            <div class="mt-6" style="font-weight: 500; font-size: 14pt;">Translated text <span v-if="translation!==''">- this text will be used for text type {{ text.type }} and language {{ getLanguage() }} if you click "use"</span></div>
            <v-textarea v-model="translation" rows="5" counter no-resize />
            <div style="display: flex; flex-direction: row; gap: 10px; align-items: center; margin-top: 10px; margin-bottom: 10px;">
                <v-spacer></v-spacer>
                <v-btn color="success" @click="closeDialogAndSendResult()" :disabled="translation===''||sel_language===''">Save</v-btn>
                <v-btn color="primary" @click="closeDialog()" :disabled="loading">Close</v-btn>
            </div>

        </v-container>
    </v-dialog>        
</template>    

<script>
export default {

    components: {
    },
    data() {
        return {
            dialog: false,
            content: this.value,
            translation_tool: 0,
            loading: false,
            sel_language: '',
            translation: '',
            text: {},
        }
    },
    created() {                 
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        open(text) {
            this.dialog = true
            this.sel_language = ''
            this.translation = ''
            this.translation_tool = 0
            this.text = text
            this.text.translatableTo.forEach((x, i) => {
                if(x.code === this.text.language)this.text.translatableTo.splice(i, 1)
            })
        },
        closeDialog() {
            this.dialog = false;
        },
        closeDialogAndSendResult() {
            this.$emit('updateData', { 
                type: this.text.type,
                source: this.text.language,
                target: this.sel_language,
                resultText: this.translation,
            })
            this.dialog = false;
        },           
        getLanguage() {
            return this.sel_language===''?'...':this.sel_language
        },
        translate(){
            this.loading=true
            if(this.sel_language==='')return
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/translateWrapper.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "translateText"
                    },
                    translateText: {
                        tool: this.translation_tool,
                        sourceLng: this.text.language, 
                        sourceText: this.text.text,
                        targetLng: this.sel_language 
                    }
                })
                .then(async res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        console.log(res.data)
                        this.translation=res.data.translateText.translatedText
                        this.loading=false
                    }
                });
        }
    }
}    
</script>

<style scoped>
  .radiogroup-font{
      font-size: 18px !important; 
  }
</style>